import { TRaceTypeFilter } from "../types";

export const TRACK_OPTIONS = {
  AGE_OPTIONS: {
    OVERSIXTEEN: "16+",
    TWELVETOFIFTEEN: "12-15",
    UNDERTWELVE: "Under 12",
  },
} as {
  AGE_OPTIONS: {
    OVERSIXTEEN: "16+";
    TWELVETOFIFTEEN: "12-15";
    UNDERTWELVE: "Under 12";
  };
};

export const TRACKS = {
  MAIN_TRACK: "MAIN_TRACK",
  MINI_TRACK: "MINI_TRACK",
  VIRTUAL_REALITY: "VIRTUAL_REALITY",
  JUNIOR_TRACK: "JUNIOR_TRACK",
  RACING_GAMES_TRACK: "RACING_GAMES_TRACK",
  BATTLE_KART_TRACK: "BATTLE_KART_TRACK",
};

export const RACE_TYPES: {
  STANDARD: TRaceTypeFilter;
  EXPERT: TRaceTypeFilter;
} = {
  STANDARD: "STANDARD",
  EXPERT: "EXPERT",
};

export const ROUTES = {
  INDEX: "/",
  MAIN_TRACK: {
    INDEX: "main-track",
    AGE_GROUP: "main-track/age-group",
    RACE_TYPE: "main-track/race-type",
    SEATS_RACES: "main-track/seats-races",
    DATE_TIME: "main-track/date-time",
    BOOKING_SUMMARY: "main-track/booking-summary",
    ReviewCart: "main-track/review-cart",
  },
  RACING_GAMES_TRACK: {
    INDEX: "racing-games-track",
    SEATS_RACES: "racing-games-track/seats-races",
    DATE_TIME: "racing-games-track/date-time",
    BOOKING_SUMMARY: "racing-games-track/booking-summary",
    ReviewCart: "racing-games-track/review-cart",
  },
  BATTLE_KART_TRACK: {
    INDEX: "battle-kart-track",
    PLAYERS_SESSIONS: "battle-kart-track/players-sessions",
    DATE_TIME: "battle-kart-track/date-time",
    BOOKING_SUMMARY: "battle-kart-track/booking-summary",
    ReviewCart: "battle-kart-track/review-cart",
  },
  JUNIOR_TRACK: {
    INDEX: "junior-track",
    SEATS_RACES: "junior-track/seats-races",
    DATE_TIME: "junior-track/date-time",
    BOOKING_SUMMARY: "junior-track/booking-summary",
    ReviewCart: "junior-track/review-cart",
  },
  MINI_TRACK: {
    INDEX: "mini-track",
    SEATS_RACES: "mini-track/seats-races",
    DATE_TIME: "mini-track/date-time",
    BOOKING_SUMMARY: "mini-track/booking-summary",
    ReviewCart: "mini-track/review-cart",
  },
  VIRTUAL_REALITY: {
    INDEX: "virtual-reality",
    PLAYERS_SESSIONS: "virtual-reality/players-sessions",
    DATE_TIME: "virtual-reality/date-time",
    CUSTOMIZEGAME: "virtual-reality/customize-game",
    BOOKING_SUMMARY: "virtual-reality/booking-summary",
    ReviewCart: "virtual-reality/review-cart",
  },
  ARCADE: {
    INDEX: "arcade",
    ARCADE_CARD: "arcade/arcade-card",
    ARCADE_EXPERIENCE: "arcade/review-experience",
    ARCADE_CART: "arcade/review-cart",
  },
};
